import React from 'react'
import AccessDenied from '@/assets/icons/access-denied.svg?react'
import { Box, SvgIcon, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export const NotFoundState: React.FC = () => {
  const { t } = useTranslation()
  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={2}
      justifyContent="center"
      alignItems="center"
      sx={{ width: '100%', minHeight: '700px' }}
    >
      <SvgIcon sx={{ fontSize: '200px' }} component={AccessDenied} inheritViewBox />
      <Typography variant="subtitle1" component="p" fontWeight={700} textAlign="center">
        {t('not-found-title')}
      </Typography>
      <Typography variant="subtitle1" component="p" fontWeight={700} textAlign="center">
        {t('contact-admin')}
      </Typography>
    </Box>
  )
}
